import styled from "styled-components";
import { RadioGroupStyled } from "../../radiobuttons/radiobuttons.styles";

export const RadioGroupFieldStyled = styled(RadioGroupStyled)``;
